import { createContext, useContext } from 'react';

export const MobilePreviewContext = createContext<HTMLDivElement | null>(null);

export const useMobilePreviewContainer = () => useContext(MobilePreviewContext);
